const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  // Compositor-driven smooth scrolling: immune to main-thread jank,
  // unlike JS rAF loops (react-scroll) fighting framer-motion.
  const navOffset = window.innerWidth <= 768 ? 72 : 80;
  const top = el.getBoundingClientRect().top + window.scrollY - navOffset;
  window.scrollTo({ top, behavior: 'smooth' });
};

export default scrollToSection;
